<template>
	<div>
		<research-header :fetched-data="fetchedData" />
		<alumni-header v-if="check" />
		<div v-if="showIfAlumni || !notAlumniPage">
			<div v-for="(block, index) in fetchedData.blocks" :key="index">
				<component
					:is="block.type"
					:index="index"
					:block="block"
					:content="block.content"
					:fetched-data="fetchedData"
				/>
			</div>
		</div>
		<main-footer />
	</div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import panels from '~/mixins/panels';

import ResearchHeader from '~/components/dev/ResearchHeader.vue';
import MainFooter from '~/components/layouts/footers/MainFooter.vue';
import AlumniHeader from '~/components/alumniHeader.vue';
import makeCanonicalLink from '~/utils/seo/makeCanonicalLink';

export default {
	components: {
		AlumniHeader,
		ResearchHeader,
		MainFooter,
	},
	mixins: [panels],
	async asyncData({ app, params, store }) {
		const { $pagesApi } = app;
		const { slug } = params;

		const [fetchedData] = await Promise.all([
			$pagesApi.contentView(slug, app.i18n.locale),
			store.dispatch('profile/getRoles'),
		]);

		if (!fetchedData) return {};

		return { fetchedData };
	},
	head() {
		return {
			title: this.fetchedData.meta_title,
			link: [
				{
					rel: 'canonical',
					hid: 'canonical',
					href: makeCanonicalLink(this.$route.path),
				},
			],
			meta: [
				{
					hid: 'robots',
					name: 'robots',
					content: this.fetchedData.meta_indexing,
				},
				{
					name: 'description',
					hid: 'description',
					content: this.fetchedData.meta_description,
				},
				// Open Graph
				{
					name: 'og:title',
					hid: 'og:title',
					content: this.fetchedData.meta_title,
				},
				{
					name: 'og:description',
					hid: 'og:description',
					content: this.fetchedData.meta_description,
				},
				{
					name: 'og:type',
					hid: 'og:type',
					content: 'article',
				},
				{
					name: 'og:image',
					hid: 'og:image',
					content: this.fetchedData.smm_image_default.src || this.fetchedData.top_cover_image_default.src,
				},
				// Twitter Card
				{
					name: 'twitter:card',
					content: 'summary',
				},
				{
					name: 'twitter:site',
					content: '@nuxt_js',
				},
				{
					name: 'twitter:title',
					content: this.fetchedData.meta_title,
				},
				{
					name: 'twitter:description',
					content: this.fetchedData.meta_description,
				},
				{
					name: 'twitter:image',
					content: this.fetchedData.top_cover_image_default.src,
				},

				{
					name: 'image',
					property: 'og:image',
					content: this.fetchedData.smm_image_default.src || this.fetchedData.top_cover_image_default.src,
				},
				{
					name: 'author',
					content: 'SKOLKOVO',
				},
			],
		};
	},
	computed: {
		check() {
			return (!this.$auth.user && this.$store.state.alumni.research)
				|| (!this.isAlumni && this.fetchedData.is_alumni);
		},
		isAlumni() {
			return this.$store.getters['profile/isAlumni'];
		},
		showIfAlumni() {
			return this.isAlumni && this.fetchedData.is_alumni;
		},
		notAlumniPage() {
			return this.$store.state.alumni.research;
		},
	},
	created() {
		this.checkValue();
		if (this.$store.state.alumni.research && !this.$auth.loggedIn) {
			this.showLoginPopup();
		}
	},
	mounted() {
		if (!this.fetchedData.is_has_blocks && this.fetchedData.project_content_download_link) {
			window.location.replace(this.fetchedData.project_content_download_link);
		}

		this.fetchedData.top_cover_image_url_default = this.fetchedData.top_cover_image_default.src;

		if (this.fetchedData.taxonomy.project && this.fetchedData.taxonomy.project.chat_id) {
			this.loadJivo(this.fetchedData.taxonomy.project.chat_id);
		} else {
			this.loadJivo();
		}
	},
	methods: {
		...mapActions({
			loadJivo: 'scripts/loadJivo',
			showLoginPopup: 'authModal/showLogin',
		}),
		...mapMutations({
			checkAlumni: 'alumni/research',
		}),
		checkValue() {
			if (this.fetchedData.is_alumni === true) {
				this.checkAlumni(true);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
	// @import "~/assets/styles/components/home/panel-about_program";
	// @import "~/assets/styles/components/layouts/article-detail";
</style>
